export default "__VITE_ASSET__O6Cpmwij__"